import styled from 'styled-components'
import { SlideInModal as SlideInModalCL } from 'syf-component-library/ui/patterns/SlideInModal'
import { isSafari } from 'helpers'
import query from 'mediaQueries'

const MAX_MODAL_WIDTH = '414px'

/*
 *     Support: Modal Footer Fixed Position
 * Description: Bottom-most content of modal is cut off when using a Modal
 *              Footer that has a fixed position.
 *         Fix: Add static height of Modal Footer to bottom padding.
 *     Related: See <FooterWrapper> support comment.
 */
export const MODAL_CONTENT_SPACING_BOTTOM = '112px'

/**
 * Height where header and footer start to occupy half of the vertical viewport
 * making hard to read the modal content when applying zoom, starting from 360px
 * which is equivalent to:
 * 200% zoom at 720px height
 * 300% zoom at 1080px height
 */
export const MIN_VIEWPORT_HEIGHT = '360px'

interface StyledPropTypes {
  role: string
}

export const SlideInModal = styled(SlideInModalCL)<StyledPropTypes>`
  max-width: ${MAX_MODAL_WIDTH};
  width: 100%;
  height: ${isSafari() ? '-webkit-fill-available' : '100vh'};
  display: flex;
  flex-direction: column;
  z-index: 3;
  &:after {
    z-index: 2;
  }
  & > div:nth-child(2) {
    overflow: auto;
    height: calc(100vh - 200px);
  }

  @media (max-height: ${MIN_VIEWPORT_HEIGHT}) {
    & > div:nth-child(2) {
      height: auto;
    }
  }
`

export const ModalContent = styled.div`
  padding: 32px 16px ${MODAL_CONTENT_SPACING_BOTTOM};
  @media ${query.greaterThanSmall} {
    padding: 32px 32px ${MODAL_CONTENT_SPACING_BOTTOM};
  }
`

export const HeaderOverrideWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
